import type { Invoice, Setup } from '@/types'
import { pad, parseDate } from '@/util/formatters/dates'

import type { Deadline } from './types'

export const getDeadline = ({
  invoice,
  setup,
}: {
  invoice: Invoice | null
  setup?: Setup
}): Deadline => {
  if (!setup || !invoice) return null

  const now = new Date()
  const invoiceDate = parseDate(invoice.date)

  if (!invoiceDate) return null

  let month = invoiceDate.getMonth() + 1
  let year = invoiceDate.getFullYear()
  let day_deadline = setup.private_deadline

  if (setup.private_deadline_following_month) {
    month += 1

    if (month === 13) {
      month = 1
      year += 1
    }
  }

  let then = new Date(year, month - 1, day_deadline, 23, 59, 59, 0)
  let dateString = pad(day_deadline) + '.' + pad(month) + '.' + year
  let passed = then <= now

  return {
    passed: passed,
    date: dateString,
    dayDeadline: day_deadline,
  }
}
